import { Box, Grid } from '@mui/material'
import Skeleton from '@mui/material/Skeleton'
import { styled } from '@mui/material/styles'

export const EmptyMessageWrapper = styled(Grid)(({ theme }) => ({
  marginTop: '-10vh',
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',

  '.message-text': {
    color: theme.palette.grey[500], //Theme.GREY,
    marginTop: '24px',
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 500,
  },
}))
export const SkeletonWrapper = styled(Skeleton)(({ theme }) => ({
  backgroundColor: theme.palette.grey[200], //Theme.GREY_SUB,
}))
export const Wrapper = styled(Box)({
  flex: 1,
  display: 'flex',
  overflowX: 'hidden',
  height: 'calc(100vh - 230px)',
  overflowY: 'auto',
})

export const WrapperContent = styled(Box)({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  // padding: '0px 16px',
})
